import Extend from 'flarum/common/extenders';
import Poll from 'ext:fof/polls/forum/models/Poll';
import commonExtend from '../common/extend';

/**
 * Applies the wrapped extenders only when fof/polls is enabled; its models
 * resolve to placeholders otherwise.
 */
const whenPolls = extenders => ({
  extend(app, extension) {
    if (!('fof-polls' in flarum.extensions)) return;
    extenders().forEach(extender => extender.extend(app, extension));
  }
});
export default [...commonExtend, whenPolls(() => [new Extend.Model(Poll).attribute('detectedLang')])];